<template>
  <div class="background">
    <v-container fluid fill-height>
      <v-row dense justify="center" align="center">
        <v-col cols="12" sm="8" md="4">
          <v-card
            style="
              background-color: #fcfcfd;
              border-radius: 10px;
              padding: 30px !important;
            "
          >
            <v-card-title
              class="d-flex align-center justify-center loginImages"
            >
              <v-img :src="titleImage" contain height="80"> </v-img>
            </v-card-title>
            <v-card-text elevation="0" class="m-0 p-0">
              <v-stepper v-model="step" elevation="0">
                <v-stepper-content step="1">
                  <v-card-text elevation="0" class="m-0 p-0" v-if="success">
                    <v-row dense align="center" justify="center">
                      <v-img
                        max-width="40"
                        src="@/assets/icons/email.svg"
                      ></v-img>
                    </v-row>
                    <v-row align="center" justify="center">
                      <h3 style="color: #8c1843; font-size: 23px">
                        Email Confirmado!
                      </h3>
                    </v-row>
                    <v-row justify="center" class="mt-10">
                      <span class="body-text-regular">
                        Bem-vindo! Seu email foi validado com sucesso.
                      </span>
                    </v-row>
                    <v-row align="center" justify="center" class="mt-10">
                      <div class="fill-width">
                        <v-btn
                          color="#B51F57"
                          class="white--text fill-width"
                          x-large
                          @click="onClick"
                        >
                          Ir para login
                        </v-btn>
                      </div>
                    </v-row>
                  </v-card-text>
                  <v-card-text
                    elevation="0"
                    class="m-0 p-0"
                    v-if="displayMessage"
                  >
                    <v-row dense align="center" justify="center">
                      <v-img
                        max-width="40"
                        src="@/assets/icons/email.svg"
                      ></v-img>
                    </v-row>
                    <v-row align="center" justify="center">
                      <h3 style="color: #8c1843; font-size: 23px">
                        Link expirado
                      </h3>
                    </v-row>
                    <v-row justify="center" class="mt-6">
                      <span class="body-text-regular text-center">
                        {{ expiredMessage }}
                      </span>
                    </v-row>
                    <v-row justify="center" class="mt-4">
                      <custom-input
                        required
                        v-model="resendEmail"
                        label="Email"
                        placeholder="Informe seu email"
                        :currentValue="resendEmail"
                        :customRule="rules.email"
                        :errorMessage="resendError"
                      ></custom-input>
                    </v-row>
                    <v-row align="center" justify="center" class="mt-4">
                      <div class="fill-width">
                        <v-btn
                          color="#B51F57"
                          class="white--text fill-width"
                          x-large
                          :loading="resending"
                          @click="resendLink"
                        >
                          Receber novo código
                        </v-btn>
                        <v-btn
                          text
                          class="fill-width mt-2"
                          @click="returnToHome"
                        >
                          Ir para login
                        </v-btn>
                      </div>
                    </v-row>
                  </v-card-text>
                </v-stepper-content>
                <v-stepper-content step="2">
                  <v-row
                    dense
                    align="center"
                    justify="center"
                    class="pa-0 ma-0"
                  >
                    <div v-if="!validatedOTP" class="text-center">
                      <span>Informe o código recebido no e-mail:</span>
                      <div class="body-text-regular mt-2">
                        Sua conta só é ativada depois que você confirmar este
                        código.
                      </div>
                    </div>
                    <v-otp-input
                      v-if="!validatedOTP"
                      plain
                      v-model="otpValue"
                      length="6"
                      type="password"
                      :disabled="loadingOtp"
                      @finish="onFinishOtp"
                    />
                  </v-row>
                  <v-row
                    dense
                    class="ma-0 pa-0"
                    align="center"
                    justify="center"
                  >
                    <custom-input
                      v-if="validatedOTP"
                      required
                      v-model="newPassword"
                      label="Nova senha"
                      placeholder="Digite a nova senha"
                      :type="showPassword ? 'text' : 'password'"
                      :customRule="rules.password"
                      :currentValue="newPassword"
                      :errorMessage="errorMessage"
                      class="mt-4"
                      :appendIcon="showPassword ? 'mdi-eye' : 'mdi-eye-closed'"
                      @iconClick="showPassword = !showPassword"
                    ></custom-input>
                    <div class="d-flex flex-column fill-width">
                      <v-btn
                        v-if="validatedOTP"
                        color="#B51F57"
                        class="white--text fill-width"
                        x-large
                        @click="submitPasswordChange"
                      >
                        Confirmar
                      </v-btn>
                    </div>
                  </v-row>
                </v-stepper-content>
              </v-stepper>
            </v-card-text>
            <v-card-actions
              class="d-flex align-center justify-center flex-column"
            >
              <div>
                <CopyRight />
              </div>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import CopyRight from "@/components/CopyRight.vue";
import customerApi from "@/shared/pitchCustomerApi";
import partnerApi from "@/shared/pitchPartnerApi";

export default {
  components: {
    CopyRight,
  },
  computed: {
    titleImage() {
      return require("@/assets/images/logo_pitch.png");
    },
    expiredMessage() {
      return (
        this.activationError ||
        "O link informado é inválido ou expirou. Informe seu email para receber um novo código."
      );
    },
  },
  data() {
    return {
      success: false,
      displayMessage: false,
      pwdRegister: false,
      step: 1,
      otpValue: null,
      loadingOtp: false,
      validatedOTP: false,
      newPassword: null,
      errorMessage: null,
      tempPassToken: null,
      showPassword: false,
      currentModule: null,
      activationError: null,
      // Vem do `validate-email`: convite do backoffice ainda precisa de senha,
      // auto-cadastro nao (o aluno ja escolheu a dele).
      passwordPending: true,
      confirming: false,
      resendEmail: null,
      resendError: null,
      resending: false,
      rules: {
        email: [
          (v) => !!v || "Campo obrigatório.",
          (v) => /.+@.+\..+/.test(v || "") || "Informe um email válido.",
        ],
        password: [
          (v) => !!v || "Campo obrigatório.",
          (v) =>
            /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%*#¢+§])[A-Za-z\d@$!%*#?$§-]{8,}$/.test(
              v
            ) ||
            "Senha deve ter pelo menos 8 caracteres, incluindo pelo menos uma letra maiuscula, um número e um caractere especial",
        ],
      },
    };
  },
  created() {
    const { module, key, token } = this.$route.query;

    if (!module) {
      this.displayMessage = true;
      return;
    }

    this.currentModule = module;

    if (module !== "aluno" && module !== "professor") {
      this.displayMessage = true;
      localStorage.removeItem("module");
      return;
    }

    // Link sem token e sempre link velho: é o formato antigo, que não expirava e
    // ativava a conta só de ser aberto. Cai direto no reenvio, sem consultar a
    // API — não há o que validar.
    if (!token) {
      this.displayMessage = true;
      return;
    }

    this.tempPassToken = token;
    this.pwdRegister = true;

    const api = module === "aluno" ? customerApi : partnerApi;

    api
      .activateAccount(key, token)
      .then((res) => this.onActivated(res))
      .catch((err) => this.onActivationFailed(err));
  },

  methods: {
    // Abrir o link não ativa mais nada: ele só prova que o convite ainda vale.
    // Daqui sempre vamos para o passo 2, onde o código é confirmado — e só
    // depois disso (ou do cadastro da senha) a conta passa a existir.
    onActivated(res) {
      if (!res.data.success) return this.onActivationFailed();

      this.passwordPending = res.data.passwordPending !== false;
      this.step = 2;
    },
    onActivationFailed(err) {
      const raw = err?.response?.data?.message;
      this.activationError = Array.isArray(raw) ? raw[0] : raw;
      this.displayMessage = true;
    },
    // O link morto deixa de ser beco sem saída: reaproveita o fluxo de
    // recuperação, que emite OTP e token novos, e cai no mesmo passo 2 onde a
    // senha é cadastrada.
    resendLink() {
      if (!this.resendEmail || !/.+@.+\..+/.test(this.resendEmail)) {
        this.resendError = "Informe um email válido.";
        return;
      }

      this.resendError = null;
      this.resending = true;

      const api = this.currentModule === "professor" ? partnerApi : customerApi;

      api
        .requestRecoverPassword(this.resendEmail)
        .then((res) => {
          this.tempPassToken = res.data.token;
          this.pwdRegister = true;
          this.displayMessage = false;
          this.activationError = null;
          this.otpValue = null;
          this.validatedOTP = false;
          // O reenvio usa a recuperação de senha: quem chega por aqui cadastra
          // uma senha nova, e é ela que ativa a conta no fim.
          this.passwordPending = true;
          this.step = 2;
          this.$root.$emit("display-alert", {
            text: "Enviamos um novo código para o seu email.",
            type: 0,
          });
        })
        .catch((err) => {
          const raw = err?.response?.data?.message;
          this.resendError = Array.isArray(raw)
            ? raw[0]
            : raw || "Não foi possível reenviar o código.";
        })
        .finally(() => {
          this.resending = false;
        });
    },
    onClick() {
      if (!this.pwdRegister) {
        this.returnToHome();
      }
    },
    returnToHome() {
      this.$router.push({
        path: "/connect",
      });
    },

    onFinishOtp() {
      this.loadingOtp = true;
      const api = this.currentModule === "aluno" ? customerApi : partnerApi;

      api
        .validateOtp(this.otpValue)
        .then((res) => {
          if (!res.data.result) {
            this.loadingOtp = false;
            this.$root.$emit("display-alert", {
              text: "Código OTP inválido, ou expirado.",
              type: 1,
            });
            return;
          }

          // Convite do backoffice: falta a senha, e é o cadastro dela que ativa
          // a conta. Auto-cadastro: a senha já existe, então o código conferido
          // é o último passo — ativamos aqui mesmo.
          if (this.passwordPending) {
            this.validatedOTP = true;
            this.loadingOtp = false;
            return;
          }

          this.finishActivation(api);
        })
        .catch(() => {
          this.loadingOtp = false;
          this.$root.$emit("display-alert", {
            text: "Código OTP inválido, ou expirado.",
            type: 1,
          });
        });
    },
    finishActivation(api) {
      this.confirming = true;

      api
        .confirmActivation({
          token: this.tempPassToken,
          otp: this.otpValue,
        })
        .then(() => {
          this.step = 1;
          this.success = true;
          this.displayMessage = false;
          this.pwdRegister = false;
        })
        .catch((err) => {
          const raw = err?.response?.data?.message;
          this.activationError = Array.isArray(raw) ? raw[0] : raw;
          this.step = 1;
          this.displayMessage = true;
        })
        .finally(() => {
          this.confirming = false;
          this.loadingOtp = false;
        });
    },
    submitPasswordChange() {
      const payload = {
        otp: this.otpValue,
        token: this.tempPassToken,
        password: this.newPassword,
      };
      const request =
        this.currentModule === "aluno"
          ? customerApi.updatePassword(payload)
          : partnerApi.updatePassword(payload);

      request
        .then(() => {
          this.$root.$emit("display-message", {
            text: "Senha cadastrada com sucesso!",
            type: 0,
          });
          this.step = 1;
          this.success = true;
          this.displayMessage = false;
          this.pwdRegister = false;
        })
        .catch((err) => {
          const raw = err?.response?.data?.message;
          this.errorMessage = Array.isArray(raw)
            ? raw[0]
            : raw || "Não foi possível cadastrar a senha, tente novamente.";
        });
    },
  },
};
</script>
<style scoped>
.background {
  background-image: url("../../assets/images/connect/customer/background-min.webp");
  height: 100vh;
  width: 100vw;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: fixed;
  top: 0;
  left: 0;
}

.primary900 {
  color: var(--dk-pink-deep, #6b1233);
}
</style>
